import Colors from '../../../../Configs/colors';

const styles = {
  tabs: {
    '& :hover': {
      // color: colors.black1,
      opacity: 1,
    },
    '& .MuiButtonBase-root': {
      color: '#2E3C40 !important',
      fontFamily: 'Nunito Sans',
      paddingTop: '0 !important',
      '&.Mui-selected': {
        color: `${Colors.primary} !important`,
        textTransform: 'none !important',
        fontWeight: '600 !important',
      },
    },
    '& .Mui-focusVisible': {
      // backgroundColor: `${colors.black1} !important`,
    },
    '& .MuiTab-root': {
      textTransform: 'none !important',
      fontSize: 14,
      fontWeight: '600',
      paddingBottom: '2px !important',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: Colors.primary,
    },
  },
  root: {
    paddingBottom: 40,
    '& table': {
      width: '100%',
      borderCollapse: 'collapse',
      '& thead tr': {
        // borderBottom: '1px solid #DADADA',
        '& td:first-child': {
          borderRadius: '10px 0 0 0',
        },
        '& td:last-child': {
          borderRadius: '0 10px 0 0',
        },
      },
      '& tbody tr': {
        border: '1px solid #E5E5E5',
      },
      '& tbody tr:nth-child(even)': {
        background: '#FDFDFD',
      },
      '& td': {
        padding: 16,
      },
    },
  },
};

export default styles;
